import QuestionModel from './QuestionModel';

export default class SurveyModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.title = data.name || '';
    this.slug = data.slug || '';
    this.questions = (data.questions || []).map(q => new QuestionModel(q));
  }
}
